// src/utils/VoiceRecognition.js

class VoiceRecognitionManager {
    constructor() {
        this.recognition = null;
        this.isListening = false;
        this.onCommandCallback = null;

        // Initialize Web Speech API
        const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;

        if (!SpeechRecognition) {
            console.error('❌ Speech Recognition not supported in this browser');
            return;
        }

        this.recognition = new SpeechRecognition();
        this.recognition.continuous = false; // Stop after one command
        this.recognition.interimResults = false;
        this.recognition.lang = 'en-US';

        // Set up event handlers
        this.recognition.onresult = (event) => {
            const transcript = event.results[0][0].transcript.toLowerCase().trim();
            console.log('🎤 Voice command recognized:', transcript);

            if (this.onCommandCallback) {
                this.onCommandCallback(transcript);
            }
        };

        this.recognition.onerror = (event) => {
            console.error('🎤 Speech recognition error:', event.error);
            this.isListening = false;
        };

        this.recognition.onend = () => {
            console.log('🎤 Voice recognition ended');
            this.isListening = false;
        };
    }

    startListening(onCommand) {
        if (!this.recognition) {
            console.error('❌ Speech Recognition not available');
            return false;
        }

        if (this.isListening) {
            console.warn('⚠️ Already listening');
            return false;
        }

        this.onCommandCallback = onCommand;

        try {
            this.recognition.start();
            this.isListening = true;
            console.log('🎤 Voice recognition started - say a command!');
            return true;
        } catch (error) {
            console.error('❌ Failed to start voice recognition:', error);
            return false;
        }
    }

    stopListening() {
        if (this.recognition && this.isListening) {
            this.recognition.stop();
            this.isListening = false;
            console.log('🎤 Voice recognition stopped');
        }
    }

    parseCommand(transcript) {
        // Map voice commands to actions
        const commandMap = {
            // Forward/Backward = Up/Down movement
            'move forward': { action: 'Move Up', count: 1 },
            'move forwards': { action: 'Move Up', count: 1 },
            'move backwards': { action: 'Move Down', count: 1 },
            'move backward': { action: 'Move Down', count: 1 },

            // Up/Down also = Up/Down movement
            'move up': { action: 'Move Up', count: 1 },
            'move down': { action: 'Move Down', count: 1 },

            // NEW: Left/Right = Left/Right movement
            'move right': { action: 'Move Right', count: 1 },
            'move left': { action: 'Move Left', count: 1 },

            // Turn = Rotate
            'turn right': { action: 'Rotate Right', count: 1 },
            'turn left': { action: 'Rotate Left', count: 1 },
            'rotate right': { action: 'Rotate Right', count: 1 },
            'rotate left': { action: 'Rotate Left', count: 1 },
            'tern right': { action: 'Rotate Right', count: 1 },
            'tern left': { action: 'Rotate Left', count: 1 },

            // Stop
            'stop': { action: 'Stop', count: 1 },
        };

        // Log for debugging
        console.log('🔍 Parsing command:', transcript);

        // Check for exact matches
        if (commandMap[transcript]) {
            return commandMap[transcript];
        }

        // Check for number in command (e.g., "move forward 3 steps")
        const numberMatch = transcript.match(/(\d+)/);
        const baseCommand = transcript.replace(/\d+/, '').replace(/steps?/, '').trim();

        if (commandMap[baseCommand]) {
            return {
                action: commandMap[baseCommand].action,
                count: numberMatch ? parseInt(numberMatch[0]) : 1
            };
        }

        console.warn('⚠️ Unknown voice command:', transcript);
        return null;
    }
}

// Create global instance
const voiceManager = new VoiceRecognitionManager();

export default voiceManager;
